import { apiClient } from '@/lib/api-client'
import type { OnboardingStatus } from './types'

export const onboardingService = {
  getStatus: () => apiClient.get<OnboardingStatus>('/api/v1/onboarding/status'),
  complete: () => apiClient.post<void>('/api/v1/onboarding/complete', {}),
}
